import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Button from "../../components/CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import deleteUserModalStyle from "../../../assets/jss/home/deleteUserModalStyle";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const RestoreUserModal = class extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Dialog
        classes={{
          root: classes.modalRoot,
          paper: classes.modal
        }}
        open={this.props.open}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="restoreUser-slide-title"
        aria-describedby="restoreUser-slide-description"
      >
        
        <DialogContent
          id="restoreUser-slide-description"
          className={classes.modalBody}
        >
            <p>Are you sure you want to restore selected user(s)?</p>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.justifyContentCenter}
        >
          <Button onClick={() => this.props.onSuccess()} color="danger" round>Restore</Button>
          <Button onClick={() => this.props.onClose()} color="primary" round>Cancel</Button>
        </DialogActions>        
      </Dialog>
    );
  }
};

RestoreUserModal.defaultProps = {
  open: false,
};
RestoreUserModal.propTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
};
export default withStyles(deleteUserModalStyle)(RestoreUserModal);
